export const SERVER_URL = "https://app.klimat.uk";
// export const SERVER_URL = "http://localhost:5100";
